<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0 text-center">E-mails</th>
        <th scope="col" class="border-0 text-center">Lançamento</th>
        <th scope="col" class="border-0 text-center">Visualizações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in products" :key="index">
        <td>{{ index }}</td>
        <td class="td-4">{{ row.name }}</td>
        <td :class="['text-center', (row.emails.length ) ? 'link' : 'no-link']">
          <d-link @click.native="openDetails(row)">Ver lista</d-link>
        </td>
        <td class="text-center"><i :class="['material-icons', (row.is_new) ? 'text-success' : 'text-danger']">{{ (row.is_new) ? 'check' : 'clear' }}</i></td>
        <td class="text-center">{{ row.views }}</td>
      </tr>
      <tr v-if="products.length === 0">
        <td colspan="5" class="no-content">Ainda não tem nenhum relatório de produto publicado.</td>
      </tr>
    </tbody>
    <view-details-modal :headers="headers" :body="body" />
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import ViewDetailsModal from './ViewDetailsModal.vue';

export default {
  name: 'report-product-table',
  components: {
    ViewDetailsModal,
  },
  props: {
    products: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        { label: 'E-mail' },
      ],
      body: [],
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    openDetails(row) {
      if (row.emails) {
        this.body = row.emails;
        this.setToggle({ type: 'view_details_modal', bool: true });
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.no-link {
  a {
    cursor: default;
  }
}
.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }
}
</style>
